var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAmenities = function SvgAmenities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 39",
    fill: "#5663FF",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.458 14.375 2.136-4.698 4.698-2.135-4.698-2.136L31.458.708l-2.135 4.698-4.698 2.136 4.698 2.135 2.135 4.698Zm-12.812.854-4.271-9.396-4.27 9.396L.707 19.5l9.396 4.27 4.271 9.397 4.27-9.396 9.397-4.271-9.396-4.27Zm12.812 9.396-2.135 4.698-4.698 2.135 4.698 2.136 2.135 4.698 2.136-4.698 4.698-2.136-4.698-2.135-2.136-4.698Z"
  })));
};
export default SvgAmenities;